import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useLoadSubmittedOrder } from '../hooks/useLoadSubmittedOrder'

type TSubmittedOrderInfo = ReturnType<typeof useLoadSubmittedOrder>['order']

const [SubmittedProvider, useSubmittedOrderCtx] =
  createContext<TSubmittedOrderInfo>(`SubmittedOrder`)

type TProps = RequiredChildren & {
  order: TSubmittedOrderInfo
}

/**
 * Provider that exposes the static info about the submitted order (payment, branch contact, ...).
 */
export const SubmittedOrderProvider: React.FC<TProps> = ({ order, children }) => {
  return <SubmittedProvider value={order}>{children}</SubmittedProvider>
}

export { useSubmittedOrderCtx }
